import type { WheelEvent } from "react";

/**
 * Bug-205: stop a focused `<input type="number">` changing its value when the
 * user scrolls the page over it.
 *
 * The browser treats the wheel as a value adjustment on a focused number
 * input, so scrolling down a long form can walk a price up or down with no
 * indication that anything changed. On a money field that is a silent data
 * corruption, which is exactly how QA hit it on the modifier size-pricing
 * table.
 *
 * Blurring is what actually prevents the adjustment — `preventDefault` alone is
 * not enough in every browser.
 *
 * `~/components/ui/input` applies this automatically for `type="number"`. Use
 * this directly only on a raw `<input type="number">` that can't use that
 * component (usually because it carries bespoke styling); the
 * `input.wheel-guard` test requires every such element to have it.
 */
export function blurOnWheel(event: WheelEvent<HTMLInputElement>): void {
  event.preventDefault();
  (event.target as HTMLInputElement).blur();
}
